<template>
  <div class="student-lesson-list">
    <div class="box-conten" v-if="studentList.length">
      <div v-for="(item, index) in studentList" :key="index" class="student-lesson">
        <div class="name"> {{ item[0].student_name }} </div>
        <div class="lesson-list">
          <div v-for="(item_min, index_min) in item" :key="index_min" class="lesson" :class="{ lessonLast: index_min+1 === item.length }">
            <div class="left">
               <div class="lesson-name"> {{ item_min.store_name }} </div>
              <div class="apply-tiem"> 报名时间: {{ item_min.pay_time }} </div>
            </div>
            <div class="right">
              <div class="lesson-times"> 总课时：{{ Number(item_min.classtimes) }} </div>
               <div class="use-lesson"> 已上课时：{{ item_min.classtimes - item_min.classtime }} </div>
              <div class="lesson-time"> 剩余课时：{{ item_min.classtime }} </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { getUserStudent } from '@api/user'

  export default {
    name: "StudetLessonList",
    data() {
      return {
        studentList: []
      }
    },
    mounted() {
      this.getUserStudentLsson();
    },
    methods: {
      getUserStudentLsson() {
        getUserStudent(this.$route.params.uid).then(res => {
          let resList = res.data.studentProduct;
          let arr = [];
          for (let i = 0; i < resList.length; i++) {
            if (resList[i].length) {
              arr.push(resList[i]);
            }
          }
          for (let i = 0; i < arr.length; i++) {
            let arr1 = []
            for (let j = 0; j < arr[i].length; j++) {
              // if (arr[i][j].classtime && arr[i][j].classtimes) {
                arr1.push(arr[i][j])
              // }
              if (j+1 === arr[i].length) {
                arr.splice(i,1,arr1);
              }
            }
          }
          let arr2 = [];
          for (let i = 0; i < arr.length; i++) {
            if (arr[i].length) {
              arr2.push(arr[i]);
            }
          }
          this.studentList = arr2;
        })
      }
    }
  }
</script>

<style scoped>
  .student-lesson-list {
    width: 100vw;
    height: 100vh;
    position: relative;
    padding: 0.2rem;
    overflow-y: scroll;
  }
    .student-lesson-list::-webkit-scrollbar{
      display: none;
    }
    .name {
      font-size: 0.29rem;
      font-weight: 550;
      padding-top: 0.1rem;
      padding-left: 0.2rem;
      color: #ffb444;
    }
    .student-lesson {
      width: 100%;
      min-height: 2rem;
      background-color: rgb(235, 243, 243);
      box-shadow: 0.1rem 0.1rem 0.1rem rgb(214, 212, 212);
      margin-bottom: 0.5rem;
      padding: 0.2rem;
      border-radius: 0.1rem;
    }
      .lesson-list {
        height: auto;
      }
        .lesson {
          margin-top: 0.1rem;
          border-bottom: 1px solid rgb(209, 209, 209);
          padding: 0.15rem 0;
          display: flex;
          justify-content: space-around;
        }
        .lessonLast {
          border: none;
        }
        .left {
          margin-bottom: 0.1rem;
          display: flex;
          justify-content: space-around;
          flex-direction: column;
        }
        .right {
          text-align: right;
        }
          .lesson-times, .lesson-time {
            width: 2rem;
          }
          .lesson-time {
            color: rgb(41, 128, 247);
          }
</style>